var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6525 9.3675L13.1525 22.8675C13.0175 23.1075 12.77 23.25 12.5 23.25C12.44 23.25 12.3725 23.2425 12.3125 23.2275C11.9825 23.1375 11.75 22.845 11.75 22.5V14.25H5.00005C4.74505 14.25 4.51255 14.1225 4.37005 13.9125C4.23505 13.7025 4.21255 13.4325 4.31005 13.2L9.56005 1.2C9.68005 0.93 9.95005 0.75 10.25 0.75H14.75C14.9975 0.75 15.23 0.87 15.3725 1.08C15.5075 1.2825 15.5375 1.545 15.4475 1.7775L12.86 8.25H20C20.2625 8.25 20.51 8.3925 20.6451 8.6175C20.7801 8.85 20.7875 9.135 20.6525 9.3675Z",
    fill: "#FFB841"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/energy-icon.700141227cc13d45e4bad65d6ad7cc40.svg";
export { ForwardRef as ReactComponent };